import {
  Avatar,
  Card,
  CardContent,
  Typography,
  Grid,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";
import React, { useContext, useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import controlTowerModalImg from "../../assets/images/controlTowerModalImg.webp";
import profileCircle from "../../assets/images/profileCircle.webp";
import modalImageOne from "../../assets/images/modalImageOne.webp";
import { userJourneyContext } from "../../states/context/userJourneyContext";
import MockDialogBox from "./MockDialogBox";
import {
  JOB_TITLE,
  LOCATION,
  MockCommandTower,
  MockWelcomeBoard,
  USER_NAME,
} from "./mockModalData";
import MockTooltipComponent from "./MockTooltipComponent";
import { getProgress, updateUserJourneyState } from "./mockUtils";
import moment from "moment-timezone";

const MockReportGeneratorComponent = () => {
  const userContext = useContext(userJourneyContext);
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [pending, setPending] = useState(false);
  const [sortTable, setSortTable] = useState(false)
  let dateObj = new Date();
  let date = dateObj.getDate();
  let year = dateObj.getFullYear();
  let month = dateObj.getMonth();

  let dateObj1 = new Date();
  let year1 = dateObj1.getFullYear();
  let month1 = dateObj1.getMonth();

  const changeOriginalDate = (dObj, d, m, y) => {
    if (m > 11) {
      m = 0;
      y = y + 1
    }
    dObj = new Date(y, m, d);
    return moment(dObj).format('ll');
  }

  const changeSortDate = (dObj, d, m, y, n) => {
    if (d + n > moment(dObj).daysInMonth()) {
      date = d + n - moment(dObj).daysInMonth();
      if (m >= 11) {
        month = 0;
        year = y + 1
      } else {
        month = m + 1
      }
    } else {
      date = d + n;
    }
    dateObj = new Date(year, month, date);
    return moment(dateObj).format('ll');
  }

  const MockPOStatus = {
    title: "146 Purchase Order Status",
    chart: [
      ["Task", "Purchase_Count"],
      ["Awaiting Response: 47 %", 47],
      ["Pending Approval: 15 %", 15],
      ["On Track : 38 %", 38],
    ],
    actual_number: {
      awaiting_response: 47,
      Pending_approval: 15,
      on_track: 38,
    },
  };

  const mockKpiCard = [
    {
      title: "Awaiting Response",
      text: "32",
      color: "#FCBAC4",
      borderColor: "3px solid #F43F5E",
      fontWeight: "400",
      lineHeight: "140%"
    },
    {
      title: "Pending Approval",
      text: "18",
      color: "#FEF3C7",
      borderColor: "3px solid #F59E0B",
      onClickColor: "#F59E0B",
      backGround: "#FEF3C7"
    },
    {
      title: "On Track",
      text: "63",
      color: "#D1FAE5",
      borderColor: "3px solid #3CD154",
      backGround: "#D1FAE5",
      border: "3px solid #3CD154"
    },
  ];

  const sortMockTableData = [
    {
      supplier_name: "Aces Garments Ltd",
      po_number: "PO2142541210",
      ex_mill_date: `${changeSortDate(dateObj, date, month, year, 14)}`,
      delays: "10 day",
      status: "awaiting",
      milestone: "Production Planning",
      documents: "5/5 uploaded",
    },
    {
      supplier_name: "HoloFischPvt Ltd.",
      po_number: "PO9878906546",
      ex_mill_date: `${changeSortDate(dateObj, date, month, year, 1)}`,
      delays: "11 day",
      status: "pending",
      milestone: "Production Finishing",
      documents: "5/5 uploaded",
    },
    {
      supplier_name: "IndustrialActivity Pvt Ltd",
      po_number: "PO8752013456",
      ex_mill_date: `${changeSortDate(dateObj, date, month, year, 2)}`,
      delays: "23 day",
      status: "on track",
      milestone: "Production Complete",
      documents: "5/5 uploaded",
    },
    {
      supplier_name: "Istabsal Limited",
      po_number: "PO3123423200",
      ex_mill_date: `${changeSortDate(dateObj, date, month, year, 1)}`,
      delays: "14 day",
      status: "awaiting",
      milestone: "QA in Progress",
      documents: "5/5 uploaded",
    },
    {
      supplier_name: "Indumenta Pvt Ltd.",
      po_number: "PO1642391892",
      ex_mill_date: `${changeSortDate(dateObj, date, month, year, 4)}`,
      delays: "1 day",
      status: "pending",
      milestone: "Shipped",
      documents: "5/5 uploaded"
    },
    {
      supplier_name: "Brics Garments Ltd",
      po_number: "PO1230302415",
      ex_mill_date: `${changeSortDate(dateObj, date, month, year, 2)}`,
      delays: "10 day",
      status: "on track",
      milestone: "Production Planning",
      documents: "5/5 uploaded",
    },
    {
      supplier_name: "Capecanary Apparel Private Limited",
      po_number: "PO1642391892",
      ex_mill_date: `${changeSortDate(dateObj, date, month, year, 1)}`,
      delays: "6 day",
      status: "on track",
      milestone: "Production Planning",
      documents: "5/5 uploaded",
    },
    {
      supplier_name: "Shunpeng Textile",
      po_number: "PO1642391887",
      ex_mill_date: `${changeSortDate(dateObj, date, month, year, 3)}`,
      delays: "3 day",
      status: "on track",
      milestone: "Production Planning",
      documents: "5/5 uploaded"
    },
  ]

  const mockTableData = [
    {
      supplier_name: "XYZ Textile",
      po_number: "PO2450781300",
      ex_mill_date: `${changeOriginalDate(dateObj1, 13, month1 + 3, year1)}`,
      delays: "7 day",
      status: "pending",
      milestone: "PO Placed",
      documents: "0/8 uploaded",
    },
    {
      supplier_name: "Arisudana Industries Limited",
      po_number: "PO1642391886",
      ex_mill_date: `${changeOriginalDate(dateObj1, 1, month1 + 1, year1)}`,
      delays: "3 day",
      status: "on track",
      milestone: "unfulfilled",
      documents: "0/8 uploaded",
    },
    {
      supplier_name: "Capecanary Apparel Private Limited",
      po_number: "PO1642391887",
      ex_mill_date: `${changeOriginalDate(dateObj1, 10, month1 + 1, year1)}`,
      delays: "1 day",
      status: "on track",
      milestone: "unfulfilled",
      documents: "0/8 uploaded",
    },
    {
      supplier_name: "Shunpeng Textile",
      po_number: "PO1642391891",
      ex_mill_date: `${changeOriginalDate(dateObj1, 12, month1 + 2, year1)}`,
      delays: "7 day",
      status: "pending",
      milestone: "PO Placed",
      documents: "0/8 uploaded",
    },
    {
      supplier_name: "CMC Textile / Mani More Textile Pvt. Ltd.",
      po_number: "PO1642391892",
      ex_mill_date: `${changeOriginalDate(dateObj1, 2, month1 + 2, year1)}`,
      delays: "2 day",
      status: "on track",
      milestone: "PO Placed",
      documents: "0/8 uploaded",
    },
    {
      supplier_name: "HoloFischPvt Ltd.",
      po_number: "PO9878906546",
      ex_mill_date: `${changeOriginalDate(dateObj1, 2, month1 + 1, year1)}`,
      delays: "11 day",
      status: "pending",
      milestone: "Production Finishing",
      documents: "5/5 uploaded",
    },
    {
      supplier_name: "ABC Textile",
      po_number: "PO2414523978",
      ex_mill_date: `${changeOriginalDate(dateObj1, 20, month1 + 2, year1)}`,
      delays: "3 day",
      status: "pending",
      milestone: "Shipped",
      documents: "2/8 uploaded",
    },
    {
      supplier_name: "CMC Textile / Mani More Textile Pvt. Ltd.",
      po_number: "PO1642391892",
      ex_mill_date: `${changeOriginalDate(dateObj1, 12, month1 + 3, year1)}`,
      delays: "6 day",
      status: "on track",
      milestone: "PO Placed",
      documents: "0/8 uploaded",
    },
    {
      supplier_name: "Arisudana Industries Limited",
      po_number: "PO1642391886",
      ex_mill_date: "Mar 18, 2022",
      ex_mill_date: `${changeOriginalDate(dateObj1, 22, month1 + 3, year1)}`,
      delays: "3 day",
      status: "awaiting",
      milestone: "unfulfilled",
      documents: "0/8 uploaded",
    },
    {
      supplier_name: "XYZ Textile",
      po_number: "PO2450365454",
      ex_mill_date: `${changeOriginalDate(dateObj1, 12, month1 + 2, year1)}`,
      delays: "7 day",
      status: "pending",
      milestone: "PO Placed",
      documents: "0/8 uploaded",
    },
    {
      supplier_name: "Capecanary Apparel Private Limited",
      po_number: "PO1642391887",
      ex_mill_date: "Mar 18, 2022",
      ex_mill_date: `${changeOriginalDate(dateObj1, 5, month1 + 3, year1)}`,
      delays: "9 day",
      status: "on track",
      milestone: "unfulfilled",
      documents: "0/8 uploaded",
    },
    {
      supplier_name: "Indumenta Pvt Ltd.",
      po_number: "PO1642391892",
      ex_mill_date: `${changeOriginalDate(dateObj1, 5, month1 + 3, year1)}`,
      delays: "1 day",
      status: "pending",
      milestone: "Shipped",
      documents: "5/5 uploaded"
    },
    {
      supplier_name: "Shunpeng Textile",
      po_number: "PO1642391891",
      ex_mill_date: `${changeOriginalDate(dateObj1, 17, month1 + 1, year1)}`,
      delays: "3 day",
      status: "on track",
      milestone: "PO Placed",
      documents: "0/8 uploaded",
    },
    {
      supplier_name: "Indumenta Pvt Ltd.",
      po_number: "PO1642391892",
      ex_mill_date: `${changeOriginalDate(dateObj1, 22, month1 + 1, year1)}`,
      delays: "1 day",
      status: "pending",
      milestone: "Shipped",
      documents: "5/5 uploaded"
    },
    {
      supplier_name: "CMC Textile / Mani More Textile Pvt. Ltd.",
      po_number: "PO1642391892",
      ex_mill_date: `${changeOriginalDate(dateObj1, 11, month1 + 3, year1)}`,
      delays: "5 day",
      status: "on track",
      milestone: "PO Placed",
      documents: "0/8 uploaded",
    },
    {
      supplier_name: "CMC Textile / Mani More Textile Pvt. Ltd.",
      po_number: "PO1642391892",
      ex_mill_date: `${changeOriginalDate(dateObj1, 26, month1 + 3, year1)}`,
      delays: "9 day",
      status: "pending",
      milestone: "PO Placed",
      documents: "0/8 uploaded",
    },
    {
      supplier_name: "ABC Textile",
      po_number: "PO2414501037",
      ex_mill_date: `${changeOriginalDate(dateObj1, 1, month1 + 2, year1)}`,
      delays: "4 day",
      status: "pending",
      milestone: "Shipped",
      documents: "6/8 uploaded",
    },
  ];

  const Title = ({ text = "Table Title", variant = "h6" }) => (
    <Typography
      variant={variant}
      style={{
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        fontWeight: "700",
        fontSize: "24px",
        lineHeight: "140%"
      }}
    >
      {text}
    </Typography>
  );

  const onClickPendingApproval = () => {
    setPending(true);
    setOpen(false);
    window.scrollTo({ top: 450, left: 0, behavior: 'smooth' });
    (async () => {
      try {
        userContext.setUserJourneyInfo(
          updateUserJourneyState(userContext.userJourneyInfo)
        );
        userContext.setUserJourneyProgress(
          getProgress(userContext.userJourneyProgress)
        );
      } catch (e) {
        console.log(e);
      }
    })();
  };

  const onClickTable = () => {
    setSortTable(true);
    setPending(false);
    (async () => {
      try {
        userContext.setUserJourneyInfo(
          updateUserJourneyState(userContext.userJourneyInfo)
        );
        userContext.setUserJourneyProgress(
          getProgress(userContext.userJourneyProgress)
        );
      } catch (e) {
        console.log(e);
      }
    })();
  };

  useEffect(() => {
    if (userContext.userJourneyInfo.payload.steps === 3) {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
  }, [userContext.userJourneyInfo.payload.steps])

  return (
    <>
      <MockDialogBox
        mockModalData={MockCommandTower}
        image={controlTowerModalImg}
        stepTitle={MockCommandTower.title}
        callback={() => setOpen(true)}
      />
      <MockDialogBox
        mockModalData={MockWelcomeBoard}
        image={modalImageOne}
        stepTitle={MockWelcomeBoard.title}
      />
      <div style={{ margin: "-8px 16px 8px" }}>
        <Grid container direction="row" justifyContent="flex-start" spacing={2}>
          <Grid item xs={6}>
            <Card elevation={1} style={{ height: "336px" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  margin: "32px",
                }}
              >
                <Avatar
                  className="user-profile"
                  style={{
                    cursor: "pointer",
                    height: "161px",
                    width: "161px",
                  }}
                  alt=""
                  src={profileCircle}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    padding: "32px",
                    paddingTop: "0px",
                  }}
                >
                  <Typography
                    style={{
                      fontWeight: 600,
                      fontSize: "22px",
                      lineHeight: "32px",
                      fontWeight: "600",
                      fontSize: "24px",
                      lineHeight: "32px",
                      letterSpacing: "0.2px",
                      color: "#252733",
                      textAlign: "right"
                    }}
                  >
                    {USER_NAME}
                  </Typography>
                  <Typography
                    style={{
                      color: "grey",
                      fontWeight: 400,
                      paddingTop: "8px",
                      fontSize: "20px",
                      lineHeight: "24px",
                      paddingTop: "8px",
                      fontSize: "20px",
                      lineHeight: "24px",
                      fontWeight: "400",
                      fontSize: "16px",
                      lineHeight: "24px",
                      letterSpacing: "0.2px",
                      color: "#000000",
                      opacity: "0.2"

                    }}
                  >
                    {JOB_TITLE}
                  </Typography>
                  <Typography
                    style={{
                      paddingTop: "8px",
                      color: "grey",
                      fontWeight: "400",
                      fontWeight: "400",
                      fontSize: "16px",
                      lineHeight: "24px",
                      letterSpacing: "0.2px",
                      color: "#000000",
                      opacity: "0.2"
                    }}
                  >
                    <i class="fas fa-map-marker-alt" style={{ width: "16px", height: "16px", fontSize: "16px" }}></i> {LOCATION}
                  </Typography>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  marginTop: "55px",
                  flexDirection: "row",
                  marginLeft: "32px",
                  marginBottom: "32px"
                }}
              >
                <Button className={classes.buttonStyle} size="small">
                  Print as PDF
                </Button>
              </div>
            </Card>
          </Grid>
          <Grid item xs={6}>
            <Card elevation={1} style={{ height: "336px" }}>
              <div style={{ margin: "16px 2% 0px -60px" }}>
                <Chart
                  width={"105%"}
                  height={"300px"}
                  marginRight={"30px"}
                  chartType="PieChart"
                  data={MockPOStatus.chart}
                  options={{
                    legend: {
                      position: "right",
                      width: "110%",
                      textStyle: {
                        fontSize: 16,
                        height: "48px",
                        lineHeight: "24px"
                      }
                    },
                    titleTextStyle: {
                      fontSize: 24,
                      fontWeight: "700",
                      fontName: "Inter",
                      marginTop: "-16px",
                      marginBottom: "32px",
                    },
                    title: MockPOStatus.title,
                    colors: ["#FCBAC4", "#D1FAE5", "#FEF3C7"],
                  }}
                />
              </div>
            </Card>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          spacing={2}
          style={{ marginTop: "8px", padding: "0px" }}
        >
          {mockKpiCard.map((card, i) =>
            card.title === "Pending Approval" ? (
              <Grid item xs={4} style={{ padding: "8px" }}>
                <MockTooltipComponent
                  title={
                    <>
                      <Typography className={classes.tooltipTitleStyle}>
                        Your purchase orders
                      </Typography>

                      <p className={classes.tooltipTextStyle}>
                        To start, take a quick look over the status of your
                        purchase orders (POs). Depending on your supplier’s
                        response, a PO can either be Awaiting Response, Pending
                        Approval or On Track. <span className={classes.newLine}>Click <b>{"Pending Approval"}</b>{" "}
                          to see which POs have new delivery dates.{" "}</span>
                      </p>
                      <Typography className={classes.stepTextStyle}>
                        (1/19)
                      </Typography>
                    </>
                  }
                  open={open}
                  placement="top"
                  popper={classes.pendingArrivalTooltip}
                  child={
                    <Card
                      style={{
                        height: "180px",
                        border: card.borderColor,
                        backgroundColor: open ? card.color : card.onClickColor,
                        borderRadius: "8px",
                        cursor: "pointer",
                      }}
                      onClick={() => userContext.userJourneyInfo.payload.steps === 3 ? onClickPendingApproval() : null}
                    >
                      <CardContent
                        style={{
                          color: open ? "#000000" : 'white',
                          fontSize: "64px",
                          fontWeight: 600,
                          textAlign: "center",
                          lineHeight: "72px",
                          letterSpacing: "0.2px"
                        }}
                      >
                        {card.text}
                      </CardContent>
                      <Typography
                        style={{
                          color: open ? "#000000" : 'white',
                          textAlign: "center",
                          fontSize: "20px",
                        }}
                      >
                        {card.title}
                      </Typography>
                    </Card>
                  }
                />
              </Grid>
            ) : (
              <Grid item xs={4}>
                <Card
                  style={{
                    height: "180px",
                    border: card.borderColor,
                    backgroundColor: card.color,
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                >
                  <CardContent
                    style={{
                      color: "#000000",
                      fontSize: "64px",
                      fontWeight: 600,
                      textAlign: "center",
                      lineHeight: "72px",
                      letterSpacing: "0.2px"
                    }}
                  >
                    {card.text}
                  </CardContent>
                  <Typography
                    style={{
                      color: "#000000",
                      textAlign: "center",
                      fontSize: "20px",
                    }}
                  >
                    {card.title}
                  </Typography>
                </Card>
              </Grid>
            )
          )}
        </Grid>
        <Grid container direction="row" style={{ marginTop: "16px" }}>
          <div className={classes.tableDiv}>
            <h2>Purchase Orders</h2><span>Sort by column headers or search a supplier to see up-to-date information on your
              purchase orders.</span>
            <div className={classes.searchMain}>
              <div className={classes.searchContainerPo}>
                <input className={classes.searchInputPo} type="text" placeholder="Search for supplier"
                  value="" /><img className={classes.searchIconPo}
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAVCAYAAABCIB6VAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEJSURBVHgBrVQBEYMwDMzNwHDApoA6KA4mAQlIQAISkIAEJGxTUBywKdjSLbkLPdrSbn/3R69JnqRtAuCHRg5Ig3wRF+SIbCADFXISYj6alB80lBVn1yGVsCvykVV0MdFKOPfIIuLf7hEvRBbRDAQaIa5DDgbS0VHstGXkbGtIh62W76WUBgX52TIG0mh544A80nqGfNzoq6Tw+Q/CT3fDCi+0jj2vELjqhxS+07qGfPARzK6BX4WGdJxEfOkag28xgmCs7Lwe9kN2Xulz0pA/K6KVyulmKLgS9pL2tsZqdMacYD0WfbQJXGB9HFFxixq+rXqF9XAfKevCqTRJPAUsvsBvzeYV/9zJG/3QbSRxFvC3AAAAAElFTkSuQmCC" />
              </div>
              <div className={classes.poList}>
                <MockTooltipComponent
                  title={
                    <>
                      <Typography className={classes.tooltipTitleStyle}>
                        Filter Purchase Orders By Ex Mill Date
                      </Typography>
                      <p className={classes.tooltipTextStyle}>
                        Find which purchase orders are close to the ex mill so you know where to focus.
                        <span className={classes.newLine}>
                          Press the drop down and select Ex Mill date.
                        </span>
                      </p>
                      <Typography className={classes.stepTextStyle}>
                        (2/19)
                      </Typography>
                    </>
                  }
                  open={pending}
                  placement="top"
                  popper={classes.exmillDateTooltip}
                  tooltipArrowStyle={classes.locationArrowStyle}
                  child={
                    <label for="sort" >Sort:</label>
                  } />
                <div className={classes.dropdownMain}>
                  <select className={classes.dropdownInput} select={"0"}
                    onChange={(e) => {
                      if (e.target.value === "2" && userContext.userJourneyInfo.payload.steps === 4) {
                        onClickTable();
                        // window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                      }
                    }}
                  >
                    <option value="0">Supplier</option>
                    <option value="1">PO Number</option>
                    <option value="2">Ex Mill Date</option>
                    <option value="3">Delays</option>
                    <option value="4">Status</option>
                    <option value="5">Milestone</option>
                    <option value="6">Documents</option>
                    <option value="7">Risks</option>
                  </select>
                </div><span><button className={classes.exportBtn} id="tableHeader">Export</button></span>
              </div>
            </div>
            <table className={classes.tableTable}>
              <thead>
                <tr className={classes.tableHeading}>
                  <th className={classes.checkbox}><input type="checkbox" /></th>
                  <th>Supplier</th>
                  <th>PO Number</th>
                  <th>Ex Mill Date</th>
                  <th>Delays</th>
                  <th className={classes.thStatus2}>Status</th>
                  <th>Milestone</th>
                  <th>Documents</th>
                  <th>Risks</th>
                </tr>
              </thead>
              <tbody>
                {!sortTable ?
                  mockTableData.map((t, i) => (
                    pending ? t.status === "pending" && <tr className={classes.tableData}>
                      <td className={classes.checkbox}><input type="checkbox" /></td>
                      <td>{t.supplier_name}</td>
                      <td>{t.po_number}</td>
                      <td>{t.ex_mill_date}</td>
                      <td>{t.delays}</td>
                      <td>
                        {t.status === "pending" && <li className={classes.status} style={{ color: "#F59E0B", background: "#FEF3C7" }}><span className={classes.statusSpan}>
                          {t.status}</span></li>}
                        {t.status === "awaiting" && <li className={classes.status} style={{ color: "#F43F5E", background: "#FFE4E6" }}><span className={classes.statusSpan}>
                          {t.status}</span></li>}
                        {t.status === "on track" && <li className={classes.status} style={{ color: "rgb(16, 185, 129)", background: "rgb(209, 250, 229)" }}><span className={classes.statusSpan}>
                          {t.status}</span></li>}
                      </td>
                      <td>{t.milestone}</td>
                      <td>{t.documents}</td>
                      <td><span class="risk"><img class="risk-image"
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIkSURBVHgBxZcxixpBFMf/HhaWKQwYuGILQYuAFhZCUghJl8bS4uC0Eis/gh/AQqwt9jMEAhYSVEhhmS6WKwROyBV2G4hwef/VPdTb231zu3o/+Ku7O+57M/PmzZsU9LwRfRF9FpVF16Ls/tm9yBH9FP0QfRVtkBB5kS36J3pQyhWNRO8Rg4yob2g4yJHB/l1GsNe/Yhg+Fd9lQUlFdJegcV93+3eHYp3J+KET+eeMc56SHPaw6QiMicEFjPvqnxrncnEv6ABX1tFUjC5o3JdNwynsMhyDQ7VWc7kcisViaJv1eo3lcokItqK3/HELA8/H4/FDFK7rat93k5aPj1Bg2zbm8zkymYzXu06nE9iu3W6j0WhAySc6UNa0bDabWK1W3m8O8Ww2C2xXq9VgQPkKBinyDFxzBLKGf0K1WsV0Og18FhWgJ2SvEBPNqgiDI8BiwmgUNpuNF5CkUCjAsqzHawYpnVJyTwd+mzpAA71e7+gep+UFOHSAZZRqJbC3NO44DlqtlnePUV8qlTAcDr3rbreLer0OJbSNGySUgHwmk4k2Ed36qfgPdvHwLJzbSqWCdDq0GbbbLRaLhfcdwV/RO//CVnqcpEaH3nBrjFN8mopb/5OKuX9BBwYI4NVLMsKpOHdRaiGCVy3LfSwkfzDJwxDOE4MlTrHKldXHC45mh3C5jAwdoWEbil6noIcZk0n+A3Z7h4Xj4zk3Neb276JvUB7P/wPA/2vz4cg32AAAAABJRU5ErkJggg=="
                        alt="" /></span></td>
                    </tr> : <tr className={classes.tableData}>
                      <td className={classes.checkbox}><input type="checkbox" /></td>
                      <td>{t.supplier_name}</td>
                      <td>{t.po_number}</td>
                      <td>{t.ex_mill_date}</td>
                      <td>{t.delays}</td>
                      <td>
                        {t.status === "pending" && <li className={classes.status} style={{ color: "#F59E0B", background: "#FEF3C7" }}><span className={classes.statusSpan}>
                          {t.status}</span></li>}
                        {t.status === "awaiting" && <li className={classes.status} style={{ color: "#F43F5E", background: "#FFE4E6" }}><span className={classes.statusSpan}>
                          {t.status}</span></li>}
                        {t.status === "on track" && <li className={classes.status} style={{ color: "rgb(16, 185, 129)", background: "rgb(209, 250, 229)" }}><span className={classes.statusSpan}>
                          {t.status}</span></li>}
                      </td>
                      <td>{t.milestone}</td>
                      <td>{t.documents}</td>
                      <td><span class="risk"><img class="risk-image"
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIkSURBVHgBxZcxixpBFMf/HhaWKQwYuGILQYuAFhZCUghJl8bS4uC0Eis/gh/AQqwt9jMEAhYSVEhhmS6WKwROyBV2G4hwef/VPdTb231zu3o/+Ku7O+57M/PmzZsU9LwRfRF9FpVF16Ls/tm9yBH9FP0QfRVtkBB5kS36J3pQyhWNRO8Rg4yob2g4yJHB/l1GsNe/Yhg+Fd9lQUlFdJegcV93+3eHYp3J+KET+eeMc56SHPaw6QiMicEFjPvqnxrncnEv6ABX1tFUjC5o3JdNwynsMhyDQ7VWc7kcisViaJv1eo3lcokItqK3/HELA8/H4/FDFK7rat93k5aPj1Bg2zbm8zkymYzXu06nE9iu3W6j0WhAySc6UNa0bDabWK1W3m8O8Ww2C2xXq9VgQPkKBinyDFxzBLKGf0K1WsV0Og18FhWgJ2SvEBPNqgiDI8BiwmgUNpuNF5CkUCjAsqzHawYpnVJyTwd+mzpAA71e7+gep+UFOHSAZZRqJbC3NO44DlqtlnePUV8qlTAcDr3rbreLer0OJbSNGySUgHwmk4k2Ed36qfgPdvHwLJzbSqWCdDq0GbbbLRaLhfcdwV/RO//CVnqcpEaH3nBrjFN8mopb/5OKuX9BBwYI4NVLMsKpOHdRaiGCVy3LfSwkfzDJwxDOE4MlTrHKldXHC45mh3C5jAwdoWEbil6noIcZk0n+A3Z7h4Xj4zk3Neb276JvUB7P/wPA/2vz4cg32AAAAABJRU5ErkJggg=="
                        alt="" /></span></td>
                    </tr>
                  ))
                  :
                  sortMockTableData.map((t, i) => (
                    <tr className={classes.tableData}>
                      <td className={classes.checkbox}><input type="checkbox" /></td>
                      <td>{t.supplier_name}</td>
                      <td>{t.po_number}</td>
                      <td>{t.ex_mill_date}</td>
                      <td>{t.delays}</td>
                      <td>
                        {t.status === "pending" && <li className={classes.status} style={{ color: "#F59E0B", background: "#FEF3C7" }}><span className={classes.statusSpan}>
                          {t.status}</span></li>}
                        {t.status === "awaiting" && <li className={classes.status} style={{ color: "#F43F5E", background: "#FFE4E6" }}><span className={classes.statusSpan}>
                          {t.status}</span></li>}
                        {t.status === "on track" && <li className={classes.status} style={{ color: "rgb(16, 185, 129)", background: "rgb(209, 250, 229)" }}><span className={classes.statusSpan}>
                          {t.status}</span></li>}
                      </td>
                      <td>{t.milestone}</td>
                      <td>{t.documents}</td>
                      <td><span class="risk"><img class="risk-image"
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIkSURBVHgBxZcxixpBFMf/HhaWKQwYuGILQYuAFhZCUghJl8bS4uC0Eis/gh/AQqwt9jMEAhYSVEhhmS6WKwROyBV2G4hwef/VPdTb231zu3o/+Ku7O+57M/PmzZsU9LwRfRF9FpVF16Ls/tm9yBH9FP0QfRVtkBB5kS36J3pQyhWNRO8Rg4yob2g4yJHB/l1GsNe/Yhg+Fd9lQUlFdJegcV93+3eHYp3J+KET+eeMc56SHPaw6QiMicEFjPvqnxrncnEv6ABX1tFUjC5o3JdNwynsMhyDQ7VWc7kcisViaJv1eo3lcokItqK3/HELA8/H4/FDFK7rat93k5aPj1Bg2zbm8zkymYzXu06nE9iu3W6j0WhAySc6UNa0bDabWK1W3m8O8Ww2C2xXq9VgQPkKBinyDFxzBLKGf0K1WsV0Og18FhWgJ2SvEBPNqgiDI8BiwmgUNpuNF5CkUCjAsqzHawYpnVJyTwd+mzpAA71e7+gep+UFOHSAZZRqJbC3NO44DlqtlnePUV8qlTAcDr3rbreLer0OJbSNGySUgHwmk4k2Ed36qfgPdvHwLJzbSqWCdDq0GbbbLRaLhfcdwV/RO//CVnqcpEaH3nBrjFN8mopb/5OKuX9BBwYI4NVLMsKpOHdRaiGCVy3LfSwkfzDJwxDOE4MlTrHKldXHC45mh3C5jAwdoWEbil6noIcZk0n+A3Z7h4Xj4zk3Neb276JvUB7P/wPA/2vz4cg32AAAAABJRU5ErkJggg=="
                        alt="" /></span></td>
                    </tr>
                  ))}
              </tbody>
            </table>
            <div className={classes.paginationMain}>
              <div className={`${classes.pages} ${classes.selectedPage}`}> 1</div>
            </div>
          </div>
        </Grid>
      </div>
    </>
  );
};

export default MockReportGeneratorComponent;

const useStyles = makeStyles((theme) => ({
  buttonStyle: {
    backgroundColor: "#363740",
    "&:hover": {
      backgroundColor: "#363740",
    },
    color: "#FFFFFF",
    padding: "16px",
    textTransform: "none",
  },
  tooltipTitleStyle: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "20px",
  },
  tooltipTextStyle: {
    marginTop: "8px",
    fontSize: "14px",
    fontFamily: "Inter",
    lineHeight: "140%",
    fontWeight: 400,
  },
  circle: {
    borderRadius: "50%",
    height: "6px",
    width: "6px",
    paddingLeft: "6px",
    paddingRight: "4px",
  },
  pendingArrivalTooltip: {
    width: "350px",
    height: "176px",
    marginBottom: "44px",
    zIndex: "1"
  },
  tableDiv: {
    gap: "16px",
    marginRight: "20px",
    width: "100%"
  },
  searchMain: {
    display: "flex",
    justifyContent: "space-between"
  },
  searchContainerPo: {
    margin: "10px 0",
    padding: "8px",
    gridGap: "8px",
    gap: "8px",
    width: "200px",
    height: "36px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    background: "#fff",
    border: "1px solid #e2e8f0",
    borderRadius: "2px"
  },
  searchInputPo: {
    order: "1",
    padding: "8px 32px 8px 8px",
    height: "33px",
    background: "#fff",
    borderRadius: "4px",
    maxWidth: "175.78px",
    border: "none"
  },
  searchIconPo: {
    cursor: "pointer",
    width: "19px",
    height: "19px",
    order: "0",
    alignSelf: "center",
    marginLeft: "16px"
  },
  poList: {
    gridGap: "8px",
    gap: "8px",
    display: "flex",
    alignItems: "center"
  },
  dropdownMain: {
    display: "flex",
    alignItems: "center"
  },
  dropdownInput: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "center",
    background: "#fff",
    border: "1px solid #e2e8f0",
    borderRadius: "2px",
    padding: "8px 16px",
    gap: "8px",
    height: "36px"
  },
  exportBtn: {
    padding: "8px 16px",
    gridGap: "8px",
    gap: "8px",
    height: "36px",
    width: "76px",
    background: "#3b82f6",
    borderRadius: "2px",
    color: "#fff",
    border: "transparent"
  },
  tableTable: {
    borderCollapse: "unset",
    textIndent: "unset",
    borderSpacing: "0 !important",
    width: "100%"
  },
  tableHeading: {
    padding: "0 8px",
    background: "#f1f5f9",
    textAlign: "left",
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "12px",
    lineHeight: "16px",
    color: "#64748b",
    height: "40px"
  },
  checkbox: {
    textAlign: "center",
    width: "38px"
  },
  thStatus2: {
    width: "150px"
  },
  tableData: {
    fontStyle: "normal",
    fontWeight: "400",
    lineBreak: "anywhere",
    fontSize: "12px",
    color: "#334155",
    padding: "8px 4px",
    textTransform: "capitalize",
    verticalAlign: "middle"
  },
  status: {
    borderRadius: "100px",
    fontSize: "18px",
    lineHeight: "16px",
    textTransform: "capitalize",
    width: "fit-content",
    padding: "2px 6px 2px 8px"
  },
  paginationMain: {
    display: "flex",
    gridGap: "16px",
    gap: "16px",
    alignItems: "center"
  },
  pages: {
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "16px",
    color: "#334155",
    cursor: "pointer"
  },
  selectedPage: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "0",
    gridGap: "10px",
    gap: "10px",
    width: "20px",
    height: "20px",
    background: "#3b82f6",
    borderRadius: "100px",
    color: "#fff"
  },
  statusSpan: {
    fontSize: "12px",
    marginLeft: "-10px"
  },
  exmillDateTooltip: {
    marginLeft: "150px",
    zIndex: "1"
  },
  locationArrowStyle: {
    marginLeft: "130px !important",
  },
  stepTextStyle: {
    padding: "0px",
    margin: "0px",
    fontSize: "14px",
    textAlign: "end",
    marginTop: "-10px",
    marginBottom: "-10px",
  },
  newLine: {
    display: "block",
    marginTop: "15px"
  }
}));